export default __webpack_public_path__ + "static/media/Group 8088.4cba4709.png";